import { render, staticRenderFns } from "./ViewCoursePage.vue?vue&type=template&id=11bd7534&scoped=true"
import script from "./ViewCoursePage.vue?vue&type=script&lang=js"
export * from "./ViewCoursePage.vue?vue&type=script&lang=js"
import style0 from "./ViewCoursePage.vue?vue&type=style&index=0&id=11bd7534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd7534",
  null
  
)

export default component.exports